import { TextField } from '@mui/material';
import { useFormFieldDef } from '../hooks/useFormFieldDef';
import { useUnqCode } from '../hooks/useUnqCode';

export const CodeFormField = ({ fieldDef }) => {
  const { value, setValue, onBlur, error, helperText, label, disabled, variant } = useFormFieldDef(fieldDef);

  // Set the maximum characters allowed, defaulting to 20 if not provided.
  const maxChars = fieldDef.maxChars ?? 200;

  // When the value changes, call the server to check if this code is unique
  // This can be disabled by setting fieldDef.unqCode = false;
  const { unqCodeErrorState } = useUnqCode(disabled || fieldDef.unqCode === false, value);

  return (
    <TextField
      fullWidth
      slotProps={{
        input: {
          maxLength: maxChars,
        }
      }}
      value={value}
      onChange={(event) => {
        const inputValue = event.target.value;
        // Convert to uppercase, remove disallowed characters, and enforce the max character limit
        const sanitizedValue = inputValue
          .toUpperCase()
          .replace(/[^A-Z0-9_]/g, '')
        setValue(sanitizedValue);
      }}
      variant={variant}
      onBlur={onBlur}
      error={unqCodeErrorState || error}
      helperText={unqCodeErrorState ?? helperText}
      label={label}
      disabled={disabled}
    />
  );
}